/* eslint-disable */

/**
 * @desc Checks for Empty string
 * @param {*} value // Accepts string, object
 */
export function isEmpty(value) {
  if (
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  ) {
    return true;
  } else {
    return false;
  }
}

export const formatCurrency = (amount, decimals = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(amount);
};

export const getAttachmentType = (fileType) => {
  if (fileType.startsWith('image')) {
    return 'file/image';
  }

  switch (fileType) {
    case 'application/pdf':
      return 'file/pdf';
    case 'text/csv':
      return 'file/csv';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return 'file/xlsx';
    default:
      throw new Error('Unsupported file type');
  }
};

export const getImageDimensions = async (file) => {
  if (!file?.type?.startsWith('image')) {
    return null;
  }

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = reject;
    img.src = file.imageUrl;
  });
};
